import Decimal from 'decimal.js'

export function add(a, b) {
    return new Decimal(a).plus(b).toNumber()
}

export function addActualPrice(a, b, c, d, e, f) {
    if (!a) {
        a = 0
    }
    if (!b) {
        b = 0
    }
    if (!c) {
        c = 0
    }
    if (!d) {
        d = 0
    }
    if (!e) {
        e = 0
    }
    if (!f) {
        f = 0
    }
    return new Decimal(a).plus(b).plus(c).plus(d)
    .plus(e)
    .plus(f)
    .toNumber()
}

export function subtract(a, b) {
    return new Decimal(a).minus(b).toNumber()
}

export function multiply(a, b) {
    return new Decimal(a).mul(b).toNumber()
}

export function divide(a, b) {
    return new Decimal(a).div(b).toNumber()
}
